(() => {
  if (window.FeohwynnHeaderDrawersInitialized) return;
  window.FeohwynnHeaderDrawersInitialized = true;

  const root = document.documentElement;
  let lastAccountTrigger = null;
  let lastSearchTrigger = null;

  const getDrawer = () => document.querySelector('[data-fw-account-drawer]');
  const getAccountTriggers = () => Array.from(document.querySelectorAll('.user-menu'));

  const closeSearch = (restoreFocus = true) => {
    root.classList.remove('showOverly', 'stopScroll', 'searchact', 'overflow-hidden');
    if (restoreFocus && lastSearchTrigger) {
      window.setTimeout(() => lastSearchTrigger?.focus(), 30);
    }
  };

  const openSearch = (trigger) => {
    lastSearchTrigger = trigger;
    setAccountState(false, false);
    root.classList.add('showOverly', 'stopScroll', 'searchact');
    window.setTimeout(() => document.querySelector('.searchDrawer input[name="q"]')?.focus(), 80);
  };

  const prepareAccountTriggers = () => {
    getAccountTriggers().forEach((trigger) => {
      trigger.setAttribute('aria-controls', 'FeohwynnAccountDrawer');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', root.classList.contains('accountdraweract') ? 'true' : 'false');
    });
  };

  const setAccountState = (open, restoreFocus = true) => {
    const drawer = getDrawer();
    if (!drawer) return;

    root.classList.toggle('accountdraweract', open);
    if (open) {
      root.classList.add('stopScroll');
    } else if (!root.classList.contains('searchact') && !root.classList.contains('showOverly')) {
      root.classList.remove('stopScroll');
    }
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    getAccountTriggers().forEach((trigger) => trigger.setAttribute('aria-expanded', open ? 'true' : 'false'));

    if (open) {
      root.classList.remove('searchact', 'showOverly', 'overflow-hidden');
      window.setTimeout(() => drawer.querySelector('.fw-account-drawer__dialog')?.focus(), 80);
    } else if (restoreFocus && lastAccountTrigger) {
      window.setTimeout(() => lastAccountTrigger?.focus(), 30);
    }
  };

  const focusableElements = (drawer) => Array.from(drawer.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter((element) => element.getClientRects().length > 0);

  document.addEventListener('click', (event) => {
    const searchCloseButton = event.target.closest('.searchDrawer .closeSearch');
    const searchOverlay = event.target.closest('.modalOverly');
    if (
      searchCloseButton ||
      (root.classList.contains('searchact') && searchOverlay)
    ) {
      event.preventDefault();
      closeSearch();
      return;
    }

    const accountClose = event.target.closest('[data-fw-account-close]');
    if (accountClose) {
      event.preventDefault();
      setAccountState(false);
      return;
    }

    const accountTrigger = event.target.closest('.user-menu');
    if (accountTrigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      lastAccountTrigger = accountTrigger;
      setAccountState(true, false);
      return;
    }

    const searchTrigger = event.target.closest('.searchIcn');
    if (searchTrigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      openSearch(searchTrigger);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains('accountdraweract')) {
      event.preventDefault();
      setAccountState(false);
      return;
    }

    if (event.key === 'Escape' && root.classList.contains('searchact')) {
      event.preventDefault();
      closeSearch();
      return;
    }

    if (!root.classList.contains('accountdraweract')) return;

    if (event.key !== 'Tab') return;
    const drawer = getDrawer();
    const focusable = drawer ? focusableElements(drawer) : [];
    if (!focusable.length) return;

    const dialog = drawer.querySelector('.fw-account-drawer__dialog');
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (document.activeElement === dialog) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:load', prepareAccountTriggers);
  prepareAccountTriggers();
})();
